import { isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { ILanguage } from "@shared/interfaces/language.interface";
import { BehaviorSubject } from "rxjs";

const LOCALES = {
  it: "it_IT",
  en: "en_US",
};

type ILanguageWithLocale = ILanguage & {
  locale: typeof LOCALES[keyof typeof LOCALES];
};

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  private _selectedLanguage = new BehaviorSubject<
  ILanguageWithLocale
  >(null);
  public selectedLanguage$ = this._selectedLanguage.asObservable();

  constructor(
    private _api: ApiService,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {}

  AppLanguageList: Array<ILanguage> = [];

  get userSelectedLanguage(): ILanguageWithLocale {
    return this._selectedLanguage.value;
  }

  set userSelectedLanguage(language: ILanguage) {
    this._selectedLanguage.next({
      ...language,
      locale: LOCALES[language.code] ?? "en_US",
    });
  }

  fillLanguages() {
    this._api
      .request<Array<ILanguage>>(ApiServiceHolder.translation.getAllLanguages())
      .subscribe((dataR) => {
        this.AppLanguageList = dataR;
      });
  }

  getWindow() {
    if (isPlatformServer(this._platformId)) {
      return null;
    }

    return window;
  }
}
